{
	"changeOrder": {
		"title": "Change Order",
		"ticker": "Ticker",
		"option": "Option",
		"tickerCompany": "Ticker/Company",
		"operation": "Operation",
		"quantity": "Quantity",
		"sum": "Sum",
		"profitability": "Profitability",
		"dateTime": "Date/Time",
		"price": "Price",
		"statusTitle": "Status",
		"term": "Term",
		"orderType": "Order Type",
		"orderDuration": "Order Duration",
		"stopPrice": "Stop Price",
		"limitPrice": "Limit Price",
		"trailPrice": "Trail Price",
		"trailPercent": "Trail Percent",
		"approximateSum": "Approximate Sum",
		"availableFunds": "Available Funds",
		"confirm": "Confirm",
		"side": {
			"buy": "Buy",
			"sell": "Sell",
			"sell_short": "Sell Short"
		},
		"terms": {
			"day": "DAY",
			"gtc": "GTC",
			"opg": "OPG",
			"cls": "CLS",
			"ioc": "IOC",
			"dayPlus": "DAY+"
		},
		"types": {
			"market": "Market",
			"limit": "Limit",
			"stop": "Stop",
			"stop_limit": "Stop Limit",
			"trailing_stop": "Trailing Stop"
		},
		"attributes": {
			"stop_loss": "Stop Loss",
			"take_profit": "Take Profit"
		}
	}
}
